<main class="canvas-wide">
  <a routerLink="/admin/releases" class="back-link" style="margin-bottom: 12px; display: inline-flex">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      width="14"
      height="14"
    >
      <path d="m15 18-6-6 6-6" />
    </svg>
    Manage releases
  </a>

  <div class="admin-head">
    <div>
      <div class="eyebrow">Admin</div>
      @if (release(); as r) {
        <h1>
          {{ r.releaseName }}
          <span class="status-tag {{ statusClass(r.status) }}">{{ r.status }}</span>
        </h1>
        <p class="head-sub">
          {{ dateRange(r) }} · Everything below was imported from Azure DevOps. Use the Live
          switches to turn off plans and cases this release shouldn't include.
        </p>
      } @else {
        <h1>Configure release</h1>
      }
    </div>
    <div class="head-actions">
      <button
        class="btn-sm primary"
        type="button"
        (click)="importFromAzure()"
        [disabled]="isImporting()"
      >
        {{ isImporting() ? 'Importing…' : 'Import from Azure' }}
      </button>
    </div>
  </div>

  @if (isLoading()) {
    <div class="suite-card">
      @for (row of skeletonRows; track row) {
        <div class="plan-row" aria-hidden="true">
          <span class="skel skel-caret"></span>
          <span class="skel skel-name"></span>
          <span class="skel skel-count"></span>
          <span class="skel skel-assignee"></span>
          <span class="skel skel-switch"></span>
        </div>
      }
    </div>
  } @else if (loadFailed()) {
    <div class="empty-note">Couldn't load this release. Go back and try again.</div>
  } @else if (suites().length === 0) {
    <div class="empty-note">
      No suites imported yet. Import from Azure to pull in this release's suites, plans, and
      cases.
    </div>
  } @else {
    @for (suite of suites(); track suite.suiteId) {
      <section class="suite-card">
        <header class="suite-head">
          <h2>{{ suite.suiteName }}</h2>
          <span class="suite-meta">
            {{ livePlanCount(suite) }} of {{ suite.testPlanSummaries.length }}
            plan{{ suite.testPlanSummaries.length === 1 ? '' : 's' }} live
          </span>
        </header>

        <div class="plans-thead" aria-hidden="true">
          <span></span>
          <span>Plan</span>
          <span class="num">Cases</span>
          <span>Assigned to</span>
          <span class="num">Live</span>
        </div>

        @for (plan of suite.testPlanSummaries; track plan.testPlanId) {
          <div class="plan-row" [class.off]="!plan.isLive">
            <button
              class="expand"
              type="button"
              (click)="togglePlanExpanded(plan)"
              [attr.aria-expanded]="isPlanExpanded(plan)"
              [attr.aria-label]="'Show cases for ' + plan.testPlanName"
            >
              <svg
                class="caret"
                [class.open]="isPlanExpanded(plan)"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
            </button>
            <span class="plan-name">
              {{ plan.testPlanName }}
              <span class="azure-id">#{{ plan.testPlanAzureId }}</span>
            </span>
            <span class="num cases-count">{{ plan.numberOfTests }}</span>
            <span class="assignee" [class.unassigned]="!plan.assignedUserName">
              {{ plan.assignedUserName ?? 'Unassigned' }}
            </span>
            <span class="num">
              <button
                class="switch"
                type="button"
                role="switch"
                [attr.aria-checked]="plan.isLive"
                [attr.aria-label]="(plan.isLive ? 'Turn off ' : 'Turn on ') + plan.testPlanName"
                [disabled]="isPlanPending(plan)"
                (click)="togglePlanLive(plan)"
              ></button>
            </span>
          </div>

          @if (isPlanExpanded(plan)) {
            @if (isCasesLoading(plan)) {
              <div class="case-note">Loading cases…</div>
            } @else {
              @for (tc of casesFor(plan); track tc.testCaseId) {
                <div class="case-row" [class.off]="!tc.isLive">
                  <span class="case-name">
                    {{ tc.testCaseName }}
                    @if (tc.testCaseAzureId > 0) {
                      <span class="azure-id">#{{ tc.testCaseAzureId }}</span>
                    } @else {
                      <span class="azure-id">local</span>
                    }
                  </span>
                  <span class="result">
                    @if (tc.isPassing === true) {
                      <span class="dot pass" title="Passing"></span>
                    } @else if (tc.isPassing === false) {
                      <span class="dot fail" title="Failing"></span>
                    } @else {
                      <span class="dot none" title="Not run"></span>
                    }
                  </span>
                  <span class="num">
                    <button
                      class="switch"
                      type="button"
                      role="switch"
                      [attr.aria-checked]="tc.isLive"
                      [attr.aria-label]="(tc.isLive ? 'Turn off ' : 'Turn on ') + tc.testCaseName"
                      [disabled]="isCasePending(tc)"
                      (click)="toggleCaseLive(tc)"
                    ></button>
                  </span>
                </div>
              } @empty {
                <div class="case-note">No cases in this plan.</div>
              }
            }
          }
        } @empty {
          <div class="case-note">No plans in this suite.</div>
        }
      </section>
    }
  }
</main>
